const endpoints = {
  development: 'localhost:3000',
  production: 'mezzo-api.nesscs.com',
  localComms: 'localhost:3002',
  validation: 'valid-api.nesscs.com',
  smartlink: 'smartlink-api.nesscs.com',
}

export default endpoints
